
// Getter Object for AccountsRoyalty. Use it by calling mapGetters from the Vuex Host Components.

import { createUserTV } from "../../../../models/user.model";
import { tv } from "../../../../models/text-value.model";
import { snakeCaseToWords } from "../../../../utility";
import {  pathOr} from 'ramda';
const invoice_status = pathOr([], ['costData', 'invoice_status']);

export const costsGetters = {
  costData: (state) => state.costData,
  costsList: (state) => state.costsList,
  costsDetails: (state) => state.costsDetails,
  cost_invoice_statusTV: (state) => {
    invoice_status(state)
    console.log({'getters.js:16 invoice_status(state)' : state.costData});
    return invoice_status(state).map(e => ({
      text: snakeCaseToWords(e[0]),
      value: e[0]
    }))
  },
}


